import { makeStyles } from '@material-ui/core';
import { classNames } from '../../utils';

const useStyles = makeStyles(() => ({
  traumatic: {
    borderRadius: '0.5rem',
    backgroundColor: '#D81E06',
    color: '#FFFFFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    lineHeight: '1.428rem',
    padding: '0.285rem 0.785rem',
    width: 'max-content',
  },
  nonTraumatic: {
    color: '#2E4469',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.375rem',
    whiteSpace: 'nowrap',
  },
}));

const TraumaticStatus = ({ traumaType = 'N', textClass = {} }) => {
  const classes = useStyles();

  if (traumaType === 'Y') {
    return (
      <div className={classes.traumatic} aria-label="Traumatic">
        Traumatic
      </div>
    );
  }

  return <span className={classNames(classes.nonTraumatic, textClass)}>Non-traumatic</span>;
};

export default TraumaticStatus;
